import { OPERATIONAL_DEFAULTS } from "@bafe/config";
import { Card, InlineNotice, Section } from "@bafe/ui";
import { Link } from "react-router";

import { LinkButton } from "../../components/LinkButton";

const RETENTION = [
	{
		id: "mailbox",
		label: "Deleting a mailbox",
		days: OPERATIONAL_DEFAULTS.mailbox_deletion_retention_days,
		detail: "Mail is recoverable through support for this long, then permanently deleted.",
	},
	{
		id: "domain",
		label: "Removing a domain",
		days: OPERATIONAL_DEFAULTS.domain_removal_retention_days,
		detail: "Everything on the domain is kept for this long before it is permanently deleted.",
	},
	{
		id: "account",
		label: "Closing your account",
		days: OPERATIONAL_DEFAULTS.account_closure_retention_days,
		detail: "Your data is held for this long after closure so you can change your mind.",
	},
];

export function DataSection() {
	return (
		<div className="flex flex-col gap-6">
			<Section
				title="What Key keeps, and for how long"
				description="Nothing is deleted the moment you ask for it. Every removal has a window where we can bring it back."
			>
				<Card flush>
					<ul>
						{RETENTION.map((item) => (
							<li
								key={item.id}
								className="flex flex-wrap items-start justify-between gap-3 border-b border-(--border-subtle) px-4 py-3.5 last:border-0"
							>
								<div className="flex max-w-prose flex-col gap-0.5">
									<p className="text-sm font-medium text-(--text-primary)">{item.label}</p>
									<p className="text-sm text-(--text-secondary)">{item.detail}</p>
								</div>
								<p className="shrink-0 text-sm text-(--text-primary)">{item.days} days</p>
							</li>
						))}
					</ul>
				</Card>
			</Section>

			<Section
				title="Your mail"
				description="Key stores your messages so it can deliver them. It does not read them, scan them for advertising or use them to train anything."
			>
				<Card className="flex flex-col gap-3">
					<p className="text-sm text-(--text-secondary)">
						You can download everything in a mailbox at any time by connecting a mail app over IMAP and
						copying the folders locally. The{" "}
						<Link to="/manage/email/mailboxes" className="underline underline-offset-2">
							Devices tab
						</Link>{" "}
						on each mailbox has the settings.
					</p>
				</Card>
			</Section>

			<Section title="Removing things">
				<div className="flex flex-wrap gap-2">
					<LinkButton to="/manage/email/mailboxes" variant="secondary">
						Delete a mailbox
					</LinkButton>
					<LinkButton to="/manage/domains" variant="secondary">
						Remove a domain
					</LinkButton>
				</div>
			</Section>

			<InlineNotice tone="info" title="Closing your Key account">
				Account closure is handled by a person so we can check it is really you and make sure nothing is
				lost.{" "}
				<Link to="/support?category=other" className="underline underline-offset-2">
					Contact support
				</Link>{" "}
				and we will confirm what will be deleted and when, before anything happens.
			</InlineNotice>
		</div>
	);
}
